import { supabase } from './supabase';

async function getAuthHeaders() {
  const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.EXPO_PUBLIC_SUPABASE_URL;
  const { data: sessionData } = await supabase.auth.getSession();
  const accessToken = sessionData?.session?.access_token;

  if (!accessToken) throw new Error('You must be logged in.');
  if (!supabaseAnonKey) throw new Error('Missing REACT_APP_SUPABASE_ANON_KEY in your .env file.');
  if (!supabaseUrl) throw new Error('Missing REACT_APP_SUPABASE_URL in your .env file.');

  return {
    supabaseUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      apikey: supabaseAnonKey,
    },
  };
}

export async function testReflectionFollowUp({
  courseId,
  reflectionQuestionId,
  reflectionPrompt,
  extraDetails,
  reflectionText,
  category,
}) {
  const { supabaseUrl, headers } = await getAuthHeaders();
  const res = await fetch(`${supabaseUrl}/functions/v1/openai-reflection-follow-up`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      test_mode: true,
      course_id: Number(courseId),
      reflection_question_id: reflectionQuestionId,
      reflection_prompt: reflectionPrompt,
      extra_details: extraDetails,
      reflection_text: reflectionText,
      category: category || undefined,
    }),
  });

  if (!res.ok) {
    const text = await res.text();
    let message = text;
    try {
      const parsed = JSON.parse(text);
      if (parsed?.error) message = parsed.error;
    } catch {}
    throw new Error(`Follow-up function error (${res.status}): ${message}`);
  }
  return await res.json();
}
